import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'view-json',
    standalone: true,
    imports: [],
    templateUrl: './view-json.component.html'
})
export class ViewJsonComponent {  
  @Input() jsonData: any;
  @Input() title: string = 'JSON Data';

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) { }

  get formattedJson(): string {
    return JSON.stringify(this.jsonData, null, 2);
  }

  get syntaxHighlightedJson(): SafeHtml {
    const json = this.formattedJson;
    
    // First escape HTML entities
    let html = json
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    
    // Then apply syntax highlighting
    html = html.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
      let cls = 'json-number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'json-key';
        } else {
          cls = 'json-string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'json-boolean';
      } else if (/null/.test(match)) {
        cls = 'json-null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
    
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedJson).then(() => {
      // Could show a toast notification here
      console.log('JSON copied to clipboard');
    });
  }
}
